import { defineComponent as _defineComponent } from 'vue'
import Icon from "../icon";
import { computed } from "vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'index',
  props: {
    title: null,
    icon: null,
    iconColor: null,
    iconSize: null
  },
  setup(__props: any) {

const props = __props as {
  // 标题文字
  title?: string;
  // 标题图标
  icon?: string;
  // icon颜色自定义
  iconColor?: string;
  // icon尺寸
  iconSize?: string;
}



// 自定义icon样式
const computedIconStyle = computed(() => {
  const styleObj: {
    color?: string;
    fontSize?: string;
  } = {};
  if (props.iconColor) {
    styleObj["color"] = props.iconColor;
  }
  if (props.iconSize) {
    styleObj["fontSize"] = `${props.iconSize}px`;
  }
  return styleObj;
});

return { __sfc: true,props, computedIconStyle, Icon }
}

})